import { render, staticRenderFns } from "./i-xlsx.vue?vue&type=template&id=504be921&scoped=true&"
import script from "./i-xlsx.vue?vue&type=script&lang=js&"
export * from "./i-xlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504be921",
  null
  
)

export default component.exports